export default class ClinicAddress {
  constructor(
    public readonly country: string,
    public readonly zip_code: string,
    public readonly address: string,
    public readonly street_address: string,
    public readonly city: string,
    public readonly entity_name: string,
    public readonly locality: string,
    public readonly state: string,
  ) {}
}
